import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/view/components/ui/sheet'
import { BasicTable } from '../../../../../components/BasicTable'
import { EmptyTransactionsTable } from '../../../../../components/EmptyTransactionsTable'
import { Spinner } from '../../../../../components/ui/spinner'
import { useCustomerTransactionTableController } from './useCustomerTransactionTableController'
import TransactionDetails from '@/view/pages/Dashboard/components/TransactionTable/components/TransactionDetails'
import { ModalEditTransaction } from '@/view/pages/Dashboard/components/TransactionTable/components/TransactionDetails/components/EditTransactionModal'

export const CustomerTransactionTable = () => {
  const {
    getPageCount,
    getPageIndex,
    handleNextPage,
    handlePreviousPage,
    isFetching,
    isLoading,
    table,
    handleRowClick,
    handleSheetState,
    selectedItem,
    setSheetOpen,
    sheetOpen,
  } = useCustomerTransactionTableController()

  return (
    <div className="w-full">
      {(isFetching || isLoading) && (
        <div className="flex h-screen items-center justify-center">
          <Spinner />
        </div>
      )}

      <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
        <SheetContent className="w-[340px] overflow-y-auto rounded-2xl bg-[#F4F5F7] p-2 xs:mr-5 xs:mt-5 xs:h-[95%] xs:w-96 xs:p-5">
          <div className="min-h-[800px]">
            <SheetHeader>
              <SheetTitle className="text-xl font-semibold">
                <div className="flex items-center justify-between">
                  <h2>Detalhes da transação</h2>

                  {selectedItem && (
                    <ModalEditTransaction selectedTransaction={selectedItem} />
                  )}
                </div>
                <div className="my-5 w-full border-b-[1px] border-gray01" />
              </SheetTitle>
            </SheetHeader>
            {selectedItem && <TransactionDetails />}
          </div>
        </SheetContent>
      </Sheet>

      {!isFetching && (
        <>
          {getPageCount() > 0 ? (
            <div>
              <BasicTable
                type="only header"
                getPageCount={getPageCount}
                getPageIndex={getPageIndex}
                handleNextPage={handleNextPage}
                handlePreviousPage={handlePreviousPage}
                table={table}
                handleRowClick={handleRowClick}
                handleSheetState={handleSheetState}
              />
            </div>
          ) : (
            <EmptyTransactionsTable />
          )}
        </>
      )}
    </div>
  )
}
